import api from './api';

// Types
export interface PerformanceTrendItem {
  week_start: string;
  entity_type: string;
  avg_score: number;
  count: number;
}

export interface IssuesByDayItem {
  date: string;
  count: number;
}

export interface GuardsBySiteItem {
  site_id: string;
  site_name: string;
  guard_count: number;
}

export interface ComplianceBreakdown {
  total_shifts: number;
  dar_submission_rate: number;
  avg_patrols: number;
  avg_notes_quality: number | null;
  detailed_notes_rate: number;
}

export interface TopIssueItem {
  rule_id: string;
  rule_name: string;
  category: string;
  severity: string;
  trigger_count: number;
  total_impact: number;
}

export interface SitePerformanceItem {
  site_id: string;
  site_name: string;
  current_score: number;
  total_patrols: number;
  total_incidents: number;
  dar_submission_rate: number;
  total_shifts: number;
  vendor_name?: string | null;
}

export const vendorAnalyticsApi = {
  getPerformanceTrends(weeks = 12) {
    return api.get<PerformanceTrendItem[]>('/vendor/analytics/performance-trends/', { params: { weeks: String(weeks) } });
  },
  getIssuesByDay(days = 30) {
    return api.get<IssuesByDayItem[]>('/vendor/analytics/issues-by-day/', { params: { days: String(days) } });
  },
  getGuardsBySite() {
    return api.get<GuardsBySiteItem[]>('/vendor/analytics/guards-by-site/');
  },
  getComplianceBreakdown(days = 30) {
    return api.get<ComplianceBreakdown>('/vendor/analytics/compliance-breakdown/', { params: { days: String(days) } });
  },
  getTopIssues(limit = 10) {
    return api.get<TopIssueItem[]>('/vendor/analytics/top-issues/', { params: { limit: String(limit) } });
  },
  getSitePerformance(days = 30) {
    return api.get<SitePerformanceItem[]>('/vendor/analytics/site-performance/', { params: { days: String(days) } });
  },
};

export const clientAnalyticsApi = {
  getPerformanceTrends(weeks = 12) {
    return api.get<PerformanceTrendItem[]>('/client/analytics/performance-trends/', { params: { weeks: String(weeks) } });
  },
  getIssuesByDay(days = 30) {
    return api.get<IssuesByDayItem[]>('/client/analytics/issues-by-day/', { params: { days: String(days) } });
  },
  getComplianceBreakdown(days = 30) {
    return api.get<ComplianceBreakdown>('/client/analytics/compliance-breakdown/', { params: { days: String(days) } });
  },
  getTopIssues(limit = 10) {
    return api.get<TopIssueItem[]>('/client/analytics/top-issues/', { params: { limit: String(limit) } });
  },
  getSitePerformance(days = 30) {
    return api.get<SitePerformanceItem[]>('/client/analytics/site-performance/', { params: { days: String(days) } });
  },
};
